import React, { useEffect, useState } from "react";
import { CiBellOn } from "react-icons/ci";
import logo from "../assets/images/newLogo.png";
import profile from "../assets/images/profile.png";
import logo1 from "../assets/images/logo.png";

export const Topbar = ({ toggleSidebar }) => {

   const [userName, setUserName] = useState("");

  useEffect(() => {
    // ✅ Fetch userData from localStorage
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        const fullName = `${parsedUser.first_name || ""} ${
          parsedUser.last_name || ""
        }`.trim();
        setUserName(fullName || parsedUser.username || "Admin");
      } catch (e) {
        console.error("Error parsing userData:", e);
      }
    }
  }, []);


  return (
    <div>
      <div className="navbar-container">
        {/* Hamburger Menu (Only Visible on Small Screens) */}
        {window.innerWidth < 992 && (
          <button onClick={toggleSidebar} className="hamburger-menu">
            ☰
          </button>
        )}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="logo-img">
            <img src={logo} />
          </div>
          <div className="nav-profileContainer">
            <div className="bell-container">
              {/* <span className="bell-icon">
              <CiBellOn />
            </span> */}
              {/* <span className="bell-count">2</span> */}
            </div>
            <p className="profile-name">{userName}</p>
            <div className="nav-profile">
              <img src={logo1} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
